// Native
import { useState } from "react"

// Components
import { Button, ButtonGroup, Divider, Flex, ModalBody, ModalFooter, Stack, Text, useDisclosure, useToast } from "@chakra-ui/react"
import { Form, Icon, Lottie, Modal } from "components"

// Config
import { API } from "config"

// Screens
import { Authenticate } from "screens"

export default function Identity({ data:consultant, onSuccess = () => {}, ...props }){

    const toast = useToast()
    const [ form, setForm ] = useState({ check_1: false, check_2: false, check_3: false })
    const [ loading, setLoading ] = useState(false)
    const auth = useDisclosure()
    const enabled = form.check_1 && form.check_2 && form.check_3

    const handleSubmit = async () => {
        setLoading(true)

        try{
            await API.put(`/customers/${consultant?.customer_id}/identity`)
            toast({ title: 'Identidade verificada', status: 'info' })
            props.onClose()
            onSuccess()
            setForm({})
        }catch(err){
            toast({ title: 'Não foi possível validar a identidade agora.', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    return(
    <>
    <Modal loading={loading} {...props}>
        <ModalBody>

            <Stack spacing={4}>
                <Lottie animation="identity" height={200} style={{ transform: 'scale(1.3)' }} />

                <Flex flexDir="column" alignItems="center" textAlign="center">
                    <Text fontSize="xl" children="Verificar identidade do usuário" />
                    <Text fontSize="sm" color="GrayText" children="Confira as regras abaixo antes de confirmar a identidade:" />
                </Flex>

                <Divider />

                <Stack px={8}>
                    <Form.Switch label="O documento foi enviado corretamente (frente/verso)" isChecked={form.check_1} onChange={e => setForm({...form, check_1: e.target.checked})} isDisabled={loading} />
                    <Form.Switch label="Nome, CPF, RG e data de nascimento são iguais ao cadastro." isChecked={form.check_2} onChange={e => setForm({...form, check_2: e.target.checked})} isDisabled={loading} />
                    <Form.Switch label="O documento está atualizado" isChecked={form.check_3} onChange={e => setForm({...form, check_3: e.target.checked})} isDisabled={loading} />
                </Stack>
            </Stack>

        </ModalBody>
        <ModalFooter>
            <ButtonGroup size="sm" isDisabled={loading}>
                <Button isLoading={loading} isDisabled={!enabled} onClick={auth.onOpen} leftIcon={<Icon name="identity" />} children="Verificar identidade" />
                <Button colorScheme="red" children="Fechar" onClick={props.onClose} />
            </ButtonGroup>
        </ModalFooter>
    </Modal>

    <Authenticate {...auth} onSuccess={handleSubmit} />
    </>
    )
}